module.exports = __webpack_public_path__ + "img/instruction-1.0ef8baba.png";